import Vue from 'vue'
import App from './App.vue'
import {Toast, Icon, Empty} from 'vant';
import 'vant/lib/index.css';

Vue.use(Toast);
Vue.use(Icon);
Vue.use(Empty);

Vue.config.productionTip = false;

const win = window;
const doc = document;

win.addEventListener('resize', change, false);

function change() {
  if (doc.documentElement.clientWidth>677){
    doc.documentElement.style.fontSize = 677 * 20 / 375 + 'px';
    return;
  }
  doc.documentElement.style.fontSize = doc.documentElement.clientWidth * 20 / 375 + 'px';
}
change();

new Vue({
  render: h => h(App),
}).$mount('#app')
